/** Workflow status only (stored on task); Overdue is computed separately. */
export const TASK_WORKFLOW_STATUS_PILL_COLORS: Record<string, string> = {
  Unassigned: '#e5e7eb',
  'To-Do': '#bfdbfe',
  'In Progress': '#fde68a',
  'On Hold': '#fcd34d',
  Completed: '#bbf7d0',
  Void: '#d6d3d1',
};

/** Second pill when a task is overdue (in addition to workflow status). */
export const OVERDUE_STATUS_PILL_COLOR = '#fecaca';
